module.exports = __webpack_public_path__ + "static/sport/bg-h5.ddf18f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/bg-h5.png
// module id = UCoM
// module chunks = 0